import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { saveCart } from "@/lib/api";
import { SAVE_CART } from "@/constants/testIds";
import { trackEvent } from "@/lib/analytics";

export default function SaveCartForm({ items, subtotal }) {
  const [expanded, setExpanded] = useState(false);
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSaving(true);
    try {
      await saveCart({ email, items, marketingConsent: consent });
      trackEvent("cart_saved", { cart_value: subtotal, quantity: items.length });
      setSaved(true);
      toast.success("Your cart is saved — we'll help you find your way back.");
    } catch {
      toast.error("Couldn't save your cart. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (saved) {
    return <p className="text-xs text-white/50 text-center">Cart saved to {email}.</p>;
  }

  if (!expanded) {
    return (
      <button
        type="button"
        data-testid={SAVE_CART.toggle}
        onClick={() => setExpanded(true)}
        className="w-full text-center text-xs font-bold uppercase tracking-wider text-white/50 hover:text-[#FF6B00] transition-colors"
      >
        Not ready? Save your cart
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-2 border border-white/10 rounded-xl p-3">
      <p className="text-xs text-white/50">
        Enter your email and we&apos;ll save your Pickle Wall setup so you can come back to it later.
      </p>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        data-testid={SAVE_CART.email}
        className="w-full bg-black/40 border border-white/15 rounded-lg px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-[#FF6B00]"
      />
      <label className="flex items-start gap-2 text-[11px] text-white/40">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          data-testid={SAVE_CART.marketingConsent}
          className="mt-0.5"
        />
        Also send me Pickle Wall news and offers (optional).
      </label>
      <button
        type="submit"
        data-testid={SAVE_CART.submit}
        disabled={saving}
        className="w-full bg-white/10 hover:bg-white/15 disabled:opacity-50 text-white font-bold uppercase tracking-wider text-xs px-4 py-2.5 inline-flex items-center justify-center gap-2 rounded-lg transition-colors"
      >
        <Mail size={12} /> {saving ? "Saving..." : "Save My Cart"}
      </button>
    </form>
  );
}
